import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import withCustomStyles from "./GBadge.style";

// Small label. `deal` (teal) is the discount badge — never red.
export const GBadge = withCustomStyles(
  ({ classes, className, tone, children }) => (
    <span className={classnames(classes.badge, classes[tone], className)}>
      {children}
    </span>
  )
);

GBadge.propTypes = {
  tone: PropTypes.oneOf(["deal", "brand", "success", "neutral", "danger"])
};
GBadge.defaultProps = { tone: "neutral" };

// Order / item status: dot + word, so color is never the only signal.
export const GStatus = withCustomStyles(
  ({ classes, className, tone, children }) => (
    <span className={classnames(classes.status, classes[tone], className)}>
      <span className={classes.dot} aria-hidden="true" />
      {children}
    </span>
  )
);

GStatus.propTypes = {
  tone: PropTypes.oneOf(["success", "brand", "neutral", "danger"])
};
GStatus.defaultProps = { tone: "neutral" };

export default GBadge;
